module.exports = require('@udemy/icons')['createIcon']('trending-graph');